export const servicesData = [
  {
    id: 1,
    title: "Aplicación de ADOS-2",
    description: "Es una evaluación que se realiza a través de juegos y actividades, diseñada para observar cómo el niño o niña se comunica, juega e interactúa con los demás. Nos ayuda a obtener información valiosa sobre su desarrollo social y comunicativo. ",
    icon: "🧠",
    includes: "Consta de 3 sesiones",
    features: [
      "Entrevista a los padres",
      "Evaluación al niño",
      "Entrega de informe"
    ]
  },
  {
    id: 2,
    title: "Aplicación de ADI-R",
    description: "Es una entrevista en profundidad con los padres o cuidadores principales. A través de preguntas sobre la historia del desarrollo, la comunicación y la conducta del niño o niña, permite comprender mejor sus características y apoyar el proceso de diagnóstico.",
    icon: "🗣️",
    includes: "Consta de 2 sesiones",
    features: [
      "Entrevista a los padres ",
      "Evaluación al niño"
    ]
  },
  {
    id: 3,
    title: "Evaluación de Terapia Ocupacional",
    description: "Se realiza a través de pautas de desarrollo, pruebas clínicas de integración sensorial y la observación del juego libre. Esta evaluación permite conocer las habilidades motoras, sensoriales, cognitivas y sociales del niño o niña, identificando fortalezas y áreas que requieren apoyo para favorecer su desarrollo integral.",
    icon: "🎯",
    includes: "Consta de 4 sesiones",
    features: [
      "Entrevista con los apoderados",
      "2 sesiones de observación y aplicación de pautas",
      "Entrega de Informe"
    ]
  },
  {
    id: 4,
    title: "Evaluación de Fonoaudiología",
    description: "Se realiza a través de observación del juego libre, comunicación espontánea y aplicación de pautas específicas para evaluación del desarrollo del lenguaje. Esta evaluación permite conocer el nivel de desarrollo del lenguaje del niño o niña, identificando fortalezas y áreas que requieren apoyo para favorecer su desarrollo integral.",
    icon: "📚",
    includes: "Consta de 2 sesiones",
    features: [
      "Entrevista + Rapport (Observación del niño / juego).",
      "Entrega de Informe"
    ]
  },
  {
    id: 5,
    title: "Sesión de Tratamiento de Terapia Ocupacional o Fonoaudiología",
    description: "",
    includes: "Detalles",
    icon: "🏃‍♂️",
    features: [
      "Duración de 45 minutos",
      "Online o presencial"
    ]
  },
  {
    id: 6,
    title: "Taller de Habilidades Sociales ",
    description: "Un espacio que fortalece comunicación y relación con pares.  Fomentamos empatía, trabajo en equipo y resolución de conflictos. Actividades adaptadas a sus necesidades y desarrollo social",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 60 minutos",
      "Presencial",
      "Grupo 1: 7 a 11 años Viernes  17:00 a 18:00",
      "Grupo 2: 4 a 6 años Viernes 16:00 a 17:00"
    ]
  },
  {
    id: 7,
    title: "Apoyo en Lectoescritura",
    description: "Intervención enfocada en potenciar las habilidades necesarias para leer y escribir, a través de estrategias lúdicas y personalizadas. Se trabaja la conciencia fonológica, el reconocimiento de letras y sonidos, la comprensión lectora y la expresión escrita, respetando el ritmo y necesidades de cada niño o niña.--",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 45 minutos",
      "Presencial",
    ]
  },
  {
    id: 8,
    title: "Asesorías para padres",
    description: "Buscamos entregar información clara, herramientas prácticas y contención emocional, para que las familias se sientan acompañadas y seguras en el proceso de crianza y desarrollo de sus hijos",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 60 minutos",
      "Online",
    ]
  },
  {
    id: 9,
    title: "Asesoría en Lactancia",
    description: "Es un espacio de acompañamiento personalizado para madres, padres y familias que buscan apoyo durante el proceso de alimentación del bebé. Nuestro objetivo es favorecer una lactancia tranquila, segura y placentera, entregando orientación práctica y emocional en cada etapa.",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 45 minutos",
      "Online o Presencial ",
    ]
  },
  {
    id: 10,
    title: "Lavado de Oídos",
    description: "Es un procedimiento seguro y rápido que permite retirar el exceso de cera (cerumen) acumulado en el conducto auditivo, evitando molestias, picazón, disminución de la audición o sensación de oído tapado.",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 45 minutos",
      "Presencial o a domicilio",
      "Evaluación Otoscópica",
      "Lavado de Oídos",
    ]
  },
  {
    id: 11,
    title: "Estimulación Temprana",
    description: "Programa dirigido a bebés y niños pequeños que busca favorecer su desarrollo motor, sensorial, cognitivo, social y emocional a través de actividades lúdicas y personalizadas, respetando su etapa de crecimiento y ritmo individual",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 45 minutos",
      "Presencial o a domicilio",
      "Paquete de 4 sesiones",
      "Incluye guía para estimular en casa",
    ]
  },
  {
    id: 12,
    title: "Estimulación Temprana en Agua",
    description: "Sesiones de estimulación realizadas en el medio acuático, que potencian el desarrollo motor, la coordinación, el vínculo afectivo y la seguridad en el agua. Este servicio se ofrece a domicilio durante la temporada de verano (octubre a marzo).",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 45 minutos",
      "A domicilio",
      "Paquete de 4 sesiones",
      "Incluye guía para estimular en casa",
    ]
  },
  {
    id: 13,
    title: "Charlas y Asesoramiento a Jardines y Colegios",
    description: "Instancias formativas dirigidas a equipos educativos, donde se entregan estrategias y herramientas prácticas sobre desarrollo infantil, inclusión y apoyo a la diversidad en el aula.",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 60 minutos",
      "Envío y entrega  de material complementario"
    ]
  },
  {
    id: 14,
    title: "Visitas Domiciliarias",
    description: "Permite observar al niño o niña en su propio entorno, identificando cómo se desenvuelve en la rutina diaria y entregando orientaciones a la familia para apoyar su desarrollo en casa",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 45 minutos",
      "A domicilio"
    ]
  },
  {
    id: 15,
    title: "Visitas a Establecimiento Educacional",
    description: "Se realiza en el jardín o colegio, con el objetivo de conocer cómo el niño o niña participa en el contexto escolar. Además, se entregan recomendaciones a los profesionales para favorecer su inclusión y aprendizaje.",
    icon: "👨‍👩‍👧‍👦",
    includes: "Detalles",
    features: [
      "Duración de 90 minutos",
      "En establecimiento educacional",
      "Entrega de informe"
    ]
  } 

  
  
];
